/**
 * Phone number handling.
 *
 * Numbers reach us in whatever shape the member typed: "0412 345 678",
 * "+61 412 345 678", "412345678". Comparing them as text is hopeless, so
 * everything here works from the digits and treats the last nine as the number
 * itself — that being the full national significant number for an Australian
 * mobile, with the leading zero or +61 country code stripped either way.
 *
 * Mirrors find_member_by_phone in migration 023. If you change the rule here,
 * change it there too or lookups will disagree with the UI about what matches.
 */

export const AU_SIGNIFICANT_DIGITS = 9;

export const phoneDigits = (value) => String(value || "").replace(/\D/g, "");

/**
 * The comparable form of a number, or "" when there isn't enough to go on.
 * Short input returns empty rather than a partial match, so a few digits can't
 * sweep up every member ending with them.
 */
export const phoneKey = (value) => {
  const digits = phoneDigits(value);
  if (digits.length < AU_SIGNIFICANT_DIGITS) return "";
  return digits.slice(-AU_SIGNIFICANT_DIGITS);
};

export const isSearchablePhone = (value) => phoneKey(value) !== "";

/**
 * Groups a partly-typed mobile as "412 345 678".
 *
 * The +61 prefix is shown beside the field rather than stored in it, so a
 * leading zero is dropped as it's typed — this matches how PersonalProfileScreen
 * already asks for a number.
 */
export const formatAuMobileInput = (value) => {
  let digits = phoneDigits(value);

  if (digits.startsWith("61") && digits.length > AU_SIGNIFICANT_DIGITS) {
    digits = digits.slice(2);
  }
  if (digits.startsWith("0")) {
    digits = digits.slice(1);
  }

  const limited = digits.slice(0, AU_SIGNIFICANT_DIGITS);

  if (limited.length <= 3) return limited;
  if (limited.length <= 6) return `${limited.slice(0, 3)} ${limited.slice(3)}`;
  return `${limited.slice(0, 3)} ${limited.slice(3, 6)} ${limited.slice(6)}`;
};
